import * as React from 'react'

import FormText, { FormStyles } from 'embed/components/FormText'
import { Mask } from 'embed/constants'
import { ZipcodeValidator } from 'common/services/Validation'
import { Fields } from 'embed/constants/fields'
import { Filter } from 'even-ts-static'

export interface Props {
  containerClass?: string
  defaultZipcode?: string
  onChange?: (fieldName: string, value: string, isValid: boolean) => void
  styles: FormStyles
  value?: string
}

const Render: React.SFC<Props> = (props: Props) => (
  <FormText
    {...props}
    fieldName={Filter.Zipcode}
    inputmode="numeric"
    label="Zip Code"
    mask={Mask.ZipCode}
    placeholder={'Enter Zip Code'}
    validate={new ZipcodeValidator().isValid}
    // eslint-disable-next-line @typescript-eslint/unbound-method
    getValidationMessage={Fields.Zipcode.validationMessage}
    type="zipcode"
  />
)

export default Render
